import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { PaymentMethodInfo } from '../../../../../shared/types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateAccountBillingMutationVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  companyName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  taxId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  taxType?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateAccountBillingMutation = { __typename?: 'Mutation', updateAccount?: { __typename?: 'UpdateAccountPayload', account: { __typename?: 'Account', companyName?: string | null, id: string, subscription: { __typename?: 'AccountSubscription', id: string, paymentMethod?: { __typename: 'PaymentCard', preferredLocale?: Types.SupportedLocale | null, taxId?: string | null, taxType?: string | null, card?: { __typename?: 'CardInfo', brand: string, expMonth: number, expYear: number, last4: string, name?: string | null } | null, billingAddress?: { __typename?: 'BillingAddress', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null } | { __typename: 'PaymentCheck' } | null } } } | null };


export const UpdateAccountBilling = /*#__PURE__*/ gql`
    mutation UpdateAccountBilling($accountId: ID!, $companyName: String, $taxId: String, $taxType: String) {
  updateAccount(
    input: {id: $accountId, companyName: $companyName, taxId: $taxId, taxType: $taxType}
  ) {
    account {
      companyName
      id
      subscription {
        id
        paymentMethod {
          ...PaymentMethodInfo
        }
      }
    }
  }
}
    ${PaymentMethodInfo}` as unknown as DocumentNode<UpdateAccountBillingMutation, UpdateAccountBillingMutationVariables>;

          

          export const useUpdateAccountBillingMutation = (options?:MutationHookOptions<UpdateAccountBillingMutation, UpdateAccountBillingMutationVariables>) => useMutation(UpdateAccountBilling, options);
          

          export type UpdateAccountBillingMutationOptions = MutationHookOptions<UpdateAccountBillingMutation, UpdateAccountBillingMutationVariables>;

          

          export type UpdateAccountBillingMutationResult = ReturnType<typeof useUpdateAccountBillingMutation>[1];

          
